import TableDataFilter from './table_data_filter'

export default {
    install: function(Vue) {
        Vue.component('TableDataFilter', TableDataFilter)
    }
}
